import { createContext, useContext, useEffect, useState } from "react";

const BasketCtx = createContext(null);
const LS_KEY = "roxy_quote_basket";

const load = () => {
    try {
        return JSON.parse(localStorage.getItem(LS_KEY)) || [];
    } catch {
        return [];
    }
};

export function BasketProvider({ children }) {
    const [items, setItems] = useState(load);

    useEffect(() => {
        try {
            localStorage.setItem(LS_KEY, JSON.stringify(items));
        } catch {}
    }, [items]);

    const add = (p, qty = 1) =>
        setItems((prev) => (prev.find((i) => i.id === p.id) ? prev : [...prev, { ...p, qty }]));
    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);
    const has = (id) => items.some((i) => i.id === id);

    return <BasketCtx.Provider value={{ items, add, remove, clear, has }}>{children}</BasketCtx.Provider>;
}

export const useBasket = () => useContext(BasketCtx);
